module.exports = __webpack_public_path__ + "img/BR.63d2bdfb.svg";